webpackJsonp([1],{

/***/ "2MjE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LqIZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q9Ol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "goQF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "na0M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rgtM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x35b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__("/5sW");

// EXTERNAL MODULE: ./node_modules/core-js/fn/promise.js
var promise = __webpack_require__("SCKt");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/core-js/fn/array/find.js
var find = __webpack_require__("0K64");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./src/core/transform-number-of-visitors-history.ts
function transformNumberOfVisitorsHistory(numberOfVisitorsHistory, teams, unit) {
    if (unit === void 0) { unit = 1; }
    return numberOfVisitorsHistory
        .map(function (h) { return h.data; })
        .reduce(function (memo, data) {
        data.forEach(function (d) { return memo[d.team] = [d.value / unit].concat(memo[d.team]); });
        return memo;
    }, teams.map(function () { return []; }));
}

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/endpoints.ts
var API_ROOT = './static';
var API_NPB_LEAGUES = API_ROOT + "/npb-leagues.json";
var API_NPB_TEAMS = API_ROOT + "/npb-teams.json";
var API_NUMBER_OF_VISITORS_HISTORY = API_ROOT + "/npb-number-of-visitors-history.json";
var API_PENNANT_RACE_HISTORY = API_ROOT + "/npb-pennant-race-history.json";

// CONCATENATED MODULE: ./src/api/driver.ts


function get(url) {
    return axios_default.a.get(url);
}
function handleResponse(resp) {
    return resp.data;
}
function fetchNpbLeagues() {
    return get(API_NPB_LEAGUES)
        .then(function (resp) { return handleResponse(resp); })
        .then(function (data) { return data.leagues; });
}
function fetchNpbTeams() {
    return get(API_NPB_TEAMS)
        .then(function (resp) { return handleResponse(resp); })
        .then(function (data) { return data.teams; });
}
function fetchNpbNumberOfVisitorsHistory() {
    return get(API_NUMBER_OF_VISITORS_HISTORY)
        .then(function (resp) { return handleResponse(resp); })
        .then(function (data) { return data.seasons; });
}
function fetchNpbPennantRaceHistory() {
    return get(API_PENNANT_RACE_HISTORY)
        .then(function (resp) { return handleResponse(resp); })
        .then(function (data) { return data.seasons; });
}

// EXTERNAL MODULE: ./node_modules/core-js/es6/array.js
var array = __webpack_require__("cUYv");
var array_default = /*#__PURE__*/__webpack_require__.n(array);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/TabList/tab-list.ts


/* harmony default export */ var tab_list = (vue_runtime_esm["a" /* default */].extend({
    name: 'TabList',
    props: {
        labels: {
            type: Array,
            required: true,
            validator: function (array) {
                return array.every(function (val) { return typeof val === 'string'; });
            }
        }
    },
    data: function () {
        return {
            current: 0
        };
    },
    methods: {
        handleClickItem: function (index) {
            this.current = Math.max(0, Math.min(index, this.labels.length - 1));
            this.$emit('click-item', index);
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72429909","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabList/tab-list.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-list"},[_c('ul',_vm._l((_vm.labels),function(label,index){return _c('li',{key:label,class:{ 'is-current': index === _vm.current }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.handleClickItem(index)}}},[_vm._v(_vm._s(label))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var TabList_tab_list = (esExports);
// CONCATENATED MODULE: ./src/components/TabList/tab-list.vue
function injectStyle (ssrContext) {
  __webpack_require__("LqIZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72429909"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  tab_list,
  TabList_tab_list,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_TabList_tab_list = (Component.exports);

// EXTERNAL MODULE: ./node_modules/lodash.range/index.js
var lodash_range = __webpack_require__("8r4o");
var lodash_range_default = /*#__PURE__*/__webpack_require__.n(lodash_range);

// EXTERNAL MODULE: ./node_modules/lodash.round/index.js
var lodash_round = __webpack_require__("rcfA");
var lodash_round_default = /*#__PURE__*/__webpack_require__.n(lodash_round);

// EXTERNAL MODULE: ./node_modules/lodash.ceil/index.js
var lodash_ceil = __webpack_require__("d7WX");
var lodash_ceil_default = /*#__PURE__*/__webpack_require__.n(lodash_ceil);

// EXTERNAL MODULE: ./node_modules/lodash.floor/index.js
var lodash_floor = __webpack_require__("fw2W");
var lodash_floor_default = /*#__PURE__*/__webpack_require__.n(lodash_floor);

// CONCATENATED MODULE: ./src/core/get-digits.ts
function getDigits(num) {
    return Math.log(num) / Math.LN10 + 1 | 0;
}

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/LegendList/legend-list.ts

/* harmony default export */ var legend_list = (vue_runtime_esm["a" /* default */].extend({
    name: 'LegendList',
    props: {
        series: {
            type: Array,
            default: function () {
                return [];
            }
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47f8916c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegendList/legend-list.vue
var legend_list_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-list"},[_c('ul',_vm._l((_vm.series),function(item){return (item.isVisible)?_c('li',{key:item.id},[_c('svg',{attrs:{"viewBox":"0 0 32 24","width":"32","height":"24"}},[_c('path',{attrs:{"d":"M0,12.5 H32","stroke":item.color}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]):_vm._e()}))])}
var legend_list_staticRenderFns = []
var legend_list_esExports = { render: legend_list_render, staticRenderFns: legend_list_staticRenderFns }
/* harmony default export */ var LegendList_legend_list = (legend_list_esExports);
// CONCATENATED MODULE: ./src/components/LegendList/legend-list.vue
function legend_list_injectStyle (ssrContext) {
  __webpack_require__("2MjE")
}
var legend_list_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var legend_list___vue_template_functional__ = false
/* styles */
var legend_list___vue_styles__ = legend_list_injectStyle
/* scopeId */
var legend_list___vue_scopeId__ = "data-v-47f8916c"
/* moduleIdentifier (server only) */
var legend_list___vue_module_identifier__ = null
var legend_list_Component = legend_list_normalizeComponent(
  legend_list,
  LegendList_legend_list,
  legend_list___vue_template_functional__,
  legend_list___vue_styles__,
  legend_list___vue_scopeId__,
  legend_list___vue_module_identifier__
)

/* harmony default export */ var components_LegendList_legend_list = (legend_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/ChartLine/chart-line.ts







var Y_AXIS_LINES_LENGTH = 5;
/* harmony default export */ var chart_line = (vue_runtime_esm["a" /* default */].extend({
    name: 'ChartLine',
    components: {
        LegendList: components_LegendList_legend_list
    },
    props: {
        svgWidth: {
            type: Number,
            default: 1140
        },
        svgHeight: {
            type: Number,
            default: 640
        },
        paddingBottom: {
            type: Number,
            default: 24
        },
        paddingLeft: {
            type: Number,
            default: 80
        },
        paddingRight: {
            type: Number,
            default: 40
        },
        series: {
            type: Array,
            required: true
        },
        lines: {
            type: Array,
            default: function () {
                return [];
            }
        },
        xAxisLabels: {
            type: Array,
            default: function () {
                return [];
            }
        },
        yAxisUnit: {
            type: String,
            default: ''
        }
    },
    computed: {
        viewBox: function () {
            return 0 + " " + 0 + " " + this.svgWidth + " " + this.svgHeight;
        },
        chartHeight: function () {
            return this.svgHeight - this.paddingBottom;
        },
        allValues: function () {
            return this.series
                .reduce(function (memo, data) {
                return memo.concat(data);
            }, []);
        },
        _maxValue: function () {
            return Math.max.apply(Math, this.allValues);
        },
        _minValue: function () {
            return Math.min.apply(Math, this.allValues);
        },
        maxValue: function () {
            return lodash_ceil_default()(this._maxValue, (getDigits(this._maxValue) - 2) * -1);
        },
        minValue: function () {
            return lodash_floor_default()(this._minValue, (getDigits(this._minValue) - 2) * -1);
        },
        valueReminder: function () {
            return this.maxValue - this.minValue;
        },
        percentOfSeries: function () {
            var _this = this;
            return this.series
                .map(function (data) { return data
                .map(function (value) { return (value - _this.minValue) / _this.valueReminder; }); });
        },
        yAxisLinePropsList: function () {
            var d = "M" + 0 + "," + .5 + " H" + this.svgWidth;
            return lodash_range_default()(0, this.chartHeight, this.chartHeight / (Y_AXIS_LINES_LENGTH - 1))
                .concat([this.chartHeight])
                .map(function (y) {
                var _y = lodash_round_default()(y, 2);
                return {
                    y: _y,
                    d: d,
                    transform: "translate(0, " + _y + ")"
                };
            });
        },
        yAxisLabelPropsList: function () {
            var _this = this;
            return [0, .5, 1]
                .map(function (value) { return ({
                value: _this.minValue + _this.valueReminder * value,
                transform: "translate(0, " + lodash_round_default()(_this.chartHeight * value * -1, 2) + ")"
            }); });
        },
        yAxisLabelTransform: function () {
            return "translate(0 " + this.chartHeight + ")";
        },
        chartWidth: function () {
            return this.svgWidth - (this.paddingLeft + this.paddingRight);
        },
        xAxisStep: function () {
            return this.chartWidth / Math.max.apply(Math, this.series.map(function (data) { return data.length - 1; }));
        },
        seriesLineTransform: function () {
            return "translate(" + this.paddingLeft + " " + this.chartHeight + ")";
        },
        seriesLinePointList: function () {
            var _this = this;
            return this.percentOfSeries
                .map(function (data) { return data
                .map(function (value, index) { return [
                lodash_round_default()(_this.xAxisStep * index, 2),
                lodash_round_default()(_this.chartHeight * value * -1, 2)
            ]; }); });
        },
        seriesLinePropsList: function () {
            var _this = this;
            return this.seriesLinePointList
                .map(function (points, i) {
                var _a = _this.lines[i], color = _a.color, isVisible = _a.isVisible;
                return {
                    isVisible: isVisible,
                    color: color,
                    points: points.map(function (p) { return p.join(' '); }).join(' ')
                };
            });
        },
        seriesDotPropsList: function () {
            return this.seriesLinePointList
                .map(function (points) {
                return points
                    .map(function (p) {
                    var x = p[0], y = p[1];
                    return {
                        transform: "translate(" + x + " " + y + ")"
                    };
                });
            });
        },
        xAxisLabelPropsList: function () {
            var _this = this;
            return this.xAxisLabels
                .map(function (label, index) {
                return {
                    value: label,
                    transform: "translate(" + lodash_round_default()(_this.xAxisStep * index, 2) + ")"
                };
            });
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a1d9658","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChartLine/chart-line.vue
var chart_line_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-line"},[_c('LegendList',{attrs:{"series":_vm.lines}}),_vm._v(" "),_c('p',{staticClass:"chart-line__unit"},[_vm._v(_vm._s(_vm.yAxisUnit))]),_vm._v(" "),_c('svg',{attrs:{"viewBox":_vm.viewBox,"width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{staticClass:"chart-line__y-step-line"},_vm._l((_vm.yAxisLinePropsList),function(line){return _c('path',{key:line.y,attrs:{"d":line.d,"transform":line.transform}})})),_vm._v(" "),_c('g',{staticClass:"chart-line__y-label"},[_c('g',{attrs:{"transform":_vm.yAxisLabelTransform}},_vm._l((_vm.yAxisLabelPropsList),function(label){return _c('text',{key:label.value,attrs:{"x":"0","y":"0","transform":label.transform}},[_vm._v(_vm._s(label.value))])}))]),_vm._v(" "),_c('g',{attrs:{"transform":_vm.seriesLineTransform}},[_c('g',{staticClass:"chart-line__series-line"},_vm._l((_vm.seriesLinePropsList),function(line,i){return (line.isVisible)?_c('polyline',{key:i,attrs:{"points":line.points,"stroke":line.color}}):_vm._e()})),_vm._v(" "),_c('g',{staticClass:"chart-line__series-dot"},_vm._l((_vm.seriesDotPropsList),function(series,i){return (_vm.seriesLinePropsList[i].isVisible)?_c('g',{key:i,attrs:{"fill":_vm.seriesLinePropsList[i].color}},_vm._l((series),function(dot,j){return _c('circle',{key:j,attrs:{"cx":"0","cy":"0","transform":dot.transform}})})):_vm._e()}))]),_vm._v(" "),_c('g',{staticClass:"chart-line__x-label"},[_c('g',{attrs:{"transform":_vm.seriesLineTransform}},_vm._l((_vm.xAxisLabelPropsList),function(label){return _c('text',{key:label.value,attrs:{"x":"0","y":"0","transform":label.transform}},[_vm._v(_vm._s(label.value))])}))])])],1)}
var chart_line_staticRenderFns = []
var chart_line_esExports = { render: chart_line_render, staticRenderFns: chart_line_staticRenderFns }
/* harmony default export */ var ChartLine_chart_line = (chart_line_esExports);
// CONCATENATED MODULE: ./src/components/ChartLine/chart-line.vue
function chart_line_injectStyle (ssrContext) {
  __webpack_require__("Q9Ol")
}
var chart_line_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var chart_line___vue_template_functional__ = false
/* styles */
var chart_line___vue_styles__ = chart_line_injectStyle
/* scopeId */
var chart_line___vue_scopeId__ = "data-v-3a1d9658"
/* moduleIdentifier (server only) */
var chart_line___vue_module_identifier__ = null
var chart_line_Component = chart_line_normalizeComponent(
  chart_line,
  ChartLine_chart_line,
  chart_line___vue_template_functional__,
  chart_line___vue_styles__,
  chart_line___vue_scopeId__,
  chart_line___vue_module_identifier__
)

/* harmony default export */ var components_ChartLine_chart_line = (chart_line_Component.exports);

// EXTERNAL MODULE: ./node_modules/core-js/fn/number/is-finite.js
var is_finite = __webpack_require__("F2xG");
var is_finite_default = /*#__PURE__*/__webpack_require__.n(is_finite);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/ChartBar/chart-bar.ts







var chart_bar_Y_AXIS_LINES_LENGTH = 5;
/* harmony default export */ var chart_bar = (vue_runtime_esm["a" /* default */].extend({
    name: 'ChartBar',
    props: {
        svgWidth: {
            type: Number,
            default: 1140
        },
        svgHeight: {
            type: Number,
            default: 640
        },
        paddingBottom: {
            type: Number,
            default: 24
        },
        paddingLeft: {
            type: Number,
            default: 120
        },
        paddingRight: {
            type: Number,
            default: 90
        },
        series: {
            type: Array,
            required: true
        },
        forcedMinValue: {
            type: Number
        },
        lines: {
            type: Array,
            default: function () {
                return [];
            }
        },
        yAxisUnit: {
            type: String,
            default: ''
        }
    },
    computed: {
        viewBox: function () {
            return 0 + " " + 0 + " " + this.svgWidth + " " + this.svgHeight;
        },
        chartHeight: function () {
            return this.svgHeight - this.paddingBottom;
        },
        visibleLines: function () {
            return this.lines
                .filter(function (line) { return line.isVisible; });
        },
        visibleSeries: function () {
            var _this = this;
            if (this.lines.length < 1) {
                return this.series;
            }
            return this.visibleLines
                .map(function (line) { return _this.series[line.id]; });
        },
        _maxValue: function () {
            return Math.max.apply(Math, this.series);
        },
        _minValue: function () {
            return Math.min.apply(Math, this.series);
        },
        maxValue: function () {
            return lodash_ceil_default()(this._maxValue, (getDigits(this._maxValue) - 2) * -1);
        },
        minValue: function () {
            if (Number.isFinite(this.forcedMinValue)) {
                return this.forcedMinValue;
            }
            return lodash_floor_default()(this._minValue, (getDigits(this._minValue) - 2) * -1);
        },
        valueReminder: function () {
            return this.maxValue - this.minValue;
        },
        percentOfSeries: function () {
            var _this = this;
            return this.visibleSeries
                .map(function (value) { return (value - _this.minValue) / _this.valueReminder; });
        },
        yAxisLinePropsList: function () {
            var d = "M" + 0 + "," + .5 + " H" + this.svgWidth;
            return lodash_range_default()(0, this.chartHeight, this.chartHeight / (chart_bar_Y_AXIS_LINES_LENGTH - 1))
                .concat([this.chartHeight])
                .map(function (y) {
                var _y = lodash_round_default()(y, 2);
                return {
                    y: _y,
                    d: d,
                    transform: "translate(0, " + _y + ")"
                };
            });
        },
        yAxisLabelPropsList: function () {
            var _this = this;
            return [0, .5, 1]
                .map(function (value) { return ({
                value: _this.minValue + _this.valueReminder * value,
                transform: "translate(0, " + lodash_round_default()(_this.chartHeight * value * -1, 2) + ")"
            }); });
        },
        yAxisLabelTransform: function () {
            return "translate(0 " + this.chartHeight + ")";
        },
        chartWidth: function () {
            return this.svgWidth - (this.paddingLeft + this.paddingRight);
        },
        xAxisStep: function () {
            return this.chartWidth / (this.visibleSeries.length - 1);
        },
        seriesLineTransform: function () {
            return "translate(" + this.paddingLeft + " " + this.chartHeight + ")";
        },
        seriesLinePointList: function () {
            var _this = this;
            return this.percentOfSeries
                .map(function (value, index) { return [
                lodash_round_default()(_this.xAxisStep * index, 2),
                lodash_round_default()(_this.chartHeight * value * -1, 2)
            ]; });
        },
        seriesLinePropsList: function () {
            var _this = this;
            return this.seriesLinePointList
                .map(function (points, i) {
                var color = _this.visibleLines[i].color;
                var x = points[0], h = points[1];
                return {
                    color: color,
                    d: "M" + 0 + "," + 0 + " V" + h,
                    transform: "translate(" + x + ")"
                };
            });
        },
        xAxisLabelPropsList: function () {
            var _this = this;
            return this.visibleLines
                .map(function (line, index) { return ({
                value: line.name,
                transform: "translate(" + lodash_round_default()(_this.xAxisStep * index, 2) + ")"
            }); });
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-348a06dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChartBar/chart-bar.vue
var chart_bar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-bar"},[_c('p',{staticClass:"chart-bar__unit"},[_vm._v(_vm._s(_vm.yAxisUnit))]),_vm._v(" "),_c('svg',{attrs:{"viewBox":_vm.viewBox,"width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{staticClass:"chart-bar__y-step-line"},_vm._l((_vm.yAxisLinePropsList),function(line){return _c('path',{key:line.y,attrs:{"d":line.d,"transform":line.transform}})})),_vm._v(" "),_c('g',{staticClass:"chart-bar__y-label"},[_c('g',{attrs:{"transform":_vm.yAxisLabelTransform}},_vm._l((_vm.yAxisLabelPropsList),function(label){return _c('text',{key:label.value,attrs:{"x":"0","y":"0","transform":label.transform}},[_vm._v(_vm._s(label.value))])}))]),_vm._v(" "),_c('g',{attrs:{"transform":_vm.seriesLineTransform}},[_c('g',{staticClass:"chart-bar__series-bar"},_vm._l((_vm.seriesLinePropsList),function(line,i){return _c('path',{key:i,attrs:{"d":line.d,"stroke":line.color,"transform":line.transform}})}))]),_vm._v(" "),_c('g',{staticClass:"chart-bar__x-label"},[_c('g',{attrs:{"transform":_vm.seriesLineTransform}},_vm._l((_vm.xAxisLabelPropsList),function(label){return _c('text',{key:label.value,attrs:{"x":"0","y":"0","transform":label.transform}},[_vm._v(_vm._s(label.value))])}))])])])}
var chart_bar_staticRenderFns = []
var chart_bar_esExports = { render: chart_bar_render, staticRenderFns: chart_bar_staticRenderFns }
/* harmony default export */ var ChartBar_chart_bar = (chart_bar_esExports);
// CONCATENATED MODULE: ./src/components/ChartBar/chart-bar.vue
function chart_bar_injectStyle (ssrContext) {
  __webpack_require__("yArI")
}
var chart_bar_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var chart_bar___vue_template_functional__ = false
/* styles */
var chart_bar___vue_styles__ = chart_bar_injectStyle
/* scopeId */
var chart_bar___vue_scopeId__ = "data-v-348a06dc"
/* moduleIdentifier (server only) */
var chart_bar___vue_module_identifier__ = null
var chart_bar_Component = chart_bar_normalizeComponent(
  chart_bar,
  ChartBar_chart_bar,
  chart_bar___vue_template_functional__,
  chart_bar___vue_styles__,
  chart_bar___vue_scopeId__,
  chart_bar___vue_module_identifier__
)

/* harmony default export */ var components_ChartBar_chart_bar = (chart_bar_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/LegendListVertical/legend-list-vertical.ts

/* harmony default export */ var legend_list_vertical = (vue_runtime_esm["a" /* default */].extend({
    name: 'LegendListVertical',
    props: {
        series: {
            type: Array,
            default: function () {
                return [];
            }
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41dbc399","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LegendListVertical/legend-list-vertical.vue
var legend_list_vertical_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-list"},[_c('ul',_vm._l((_vm.series),function(item){return (item.isVisible)?_c('li',{key:item.id},[_c('svg',{attrs:{"viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":item.color,"transform":"translate(4 4)"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])]):_vm._e()}))])}
var legend_list_vertical_staticRenderFns = []
var legend_list_vertical_esExports = { render: legend_list_vertical_render, staticRenderFns: legend_list_vertical_staticRenderFns }
/* harmony default export */ var LegendListVertical_legend_list_vertical = (legend_list_vertical_esExports);
// CONCATENATED MODULE: ./src/components/LegendListVertical/legend-list-vertical.vue
function legend_list_vertical_injectStyle (ssrContext) {
  __webpack_require__("rgtM")
}
var legend_list_vertical_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var legend_list_vertical___vue_template_functional__ = false
/* styles */
var legend_list_vertical___vue_styles__ = legend_list_vertical_injectStyle
/* scopeId */
var legend_list_vertical___vue_scopeId__ = "data-v-41dbc399"
/* moduleIdentifier (server only) */
var legend_list_vertical___vue_module_identifier__ = null
var legend_list_vertical_Component = legend_list_vertical_normalizeComponent(
  legend_list_vertical,
  LegendListVertical_legend_list_vertical,
  legend_list_vertical___vue_template_functional__,
  legend_list_vertical___vue_styles__,
  legend_list_vertical___vue_scopeId__,
  legend_list_vertical___vue_module_identifier__
)

/* harmony default export */ var components_LegendListVertical_legend_list_vertical = (legend_list_vertical_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/ChartPie/chart-pie.ts



var PIE2 = 2 * Math.PI;
/* harmony default export */ var chart_pie = (vue_runtime_esm["a" /* default */].extend({
    name: 'ChartPie',
    components: {
        LegendListVertical: components_LegendListVertical_legend_list_vertical
    },
    props: {
        svgWidth: {
            type: Number,
            default: 640
        },
        svgHeight: {
            type: Number,
            default: 640
        },
        chartR: {
            type: Number,
            default: 160
        },
        series: {
            type: Array,
            required: true
        },
        pies: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    computed: {
        viewBox: function () {
            return this.svgWidth / -2 + " " + this.svgHeight / -2 + " " + this.svgWidth + " " + this.svgHeight;
        },
        visiblePies: function () {
            return this.pies
                .filter(function (line) { return line.isVisible; });
        },
        visibleSeries: function () {
            var _this = this;
            if (this.pies.length < 1) {
                return this.series;
            }
            return this.visiblePies
                .map(function (line) { return _this.series[line.id]; });
        },
        totalValue: function () {
            return this.visibleSeries.reduce(function (memo, value) { return memo + value; }, 0);
        },
        percentOfSeries: function () {
            var _this = this;
            var subTotal = 0;
            return this.visibleSeries
                .map(function (value, i) {
                if (i === _this.visibleSeries.length - 1) {
                    return 1 - subTotal;
                }
                var percentage = value / _this.totalValue;
                subTotal += percentage;
                return percentage;
            });
        },
        // seriesPie
        seriesPiePropsList: function () {
            var _this = this;
            var x1 = this.chartR * Math.cos(0);
            var y1 = this.chartR * Math.sin(0);
            var subTotal = 0;
            return this.percentOfSeries
                .map(function (value, i) { return ({ value: value, team: i }); })
                .sort(function (a, b) { return b.value - a.value; })
                .map(function (_a) {
                var value = _a.value, team = _a.team;
                var color = _this.visiblePies[team].color;
                var x2 = _this.chartR * Math.cos(PIE2 * value);
                var y2 = _this.chartR * Math.sin(PIE2 * value);
                var matrix = [lodash_round_default()(Math.cos(PIE2 * subTotal), 4), lodash_round_default()(Math.sin(PIE2 * subTotal), 4)];
                matrix.push(matrix[1] * -1, matrix[0], 0, 1);
                subTotal += value;
                return {
                    value: value,
                    color: color,
                    d: "M " + x1 + " " + y1 + " a " + _this.chartR + " " + _this.chartR + " " + 0 + " " + (value > .5 ? 1 : 0) + " " + 1 + " " + lodash_round_default()(x2 - x1, 2) + " " + lodash_round_default()(y2 - y1, 2),
                    transform: "matrix(" + matrix.join(' ') + ")"
                };
            });
        }
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f035c1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChartPie/chart-pie.vue
var chart_pie_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-pie"},[_c('svg',{attrs:{"viewBox":_vm.viewBox,"width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('g',{staticClass:"chart-pie__series-pie"},_vm._l((_vm.seriesPiePropsList),function(pie,i){return _c('path',{key:i,attrs:{"d":pie.d,"stroke":pie.color,"transform":pie.transform}})}))]),_vm._v(" "),_c('LegendListVertical',{attrs:{"series":_vm.pies}})],1)}
var chart_pie_staticRenderFns = []
var chart_pie_esExports = { render: chart_pie_render, staticRenderFns: chart_pie_staticRenderFns }
/* harmony default export */ var ChartPie_chart_pie = (chart_pie_esExports);
// CONCATENATED MODULE: ./src/components/ChartPie/chart-pie.vue
function chart_pie_injectStyle (ssrContext) {
  __webpack_require__("goQF")
}
var chart_pie_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var chart_pie___vue_template_functional__ = false
/* styles */
var chart_pie___vue_styles__ = chart_pie_injectStyle
/* scopeId */
var chart_pie___vue_scopeId__ = "data-v-34f035c1"
/* moduleIdentifier (server only) */
var chart_pie___vue_module_identifier__ = null
var chart_pie_Component = chart_pie_normalizeComponent(
  chart_pie,
  ChartPie_chart_pie,
  chart_pie___vue_template_functional__,
  chart_pie___vue_styles__,
  chart_pie___vue_scopeId__,
  chart_pie___vue_module_identifier__
)

/* harmony default export */ var components_ChartPie_chart_pie = (chart_pie_Component.exports);

// CONCATENATED MODULE: ./node_modules/ts-loader!./node_modules/tslint-loader!./src/components/App/app.ts









/* harmony default export */ var app = (vue_runtime_esm["a" /* default */].extend({
    name: 'app',
    components: {
        TabList: components_TabList_tab_list,
        ChartLine: components_ChartLine_chart_line,
        ChartBar: components_ChartBar_chart_bar,
        ChartPie: components_ChartPie_chart_pie
    },
    data: function () {
        return {
            leagues: [],
            teams: [],
            numberOfVisitorsHistory: [],
            pennantRaceHistory: [],
            lineChartCurrentLeague: 0,
            barChartCurrentLeague: 0,
            barChartCurrentSeason: null,
            pieChartCurrentLeague: 0,
            pieChartCurrentSeason: null
        };
    },
    computed: {
        tabLabels: function () {
            return this.leagues
                .map(function (l) { return l.name; });
        },
        lineChartHistoryList: function () {
            return transformNumberOfVisitorsHistory(this.numberOfVisitorsHistory, this.teams, 1000);
        },
        lineChartPropsList: function () {
            var _this = this;
            return this.teams
                .map(function (t) { return ({
                id: t.id,
                name: t.name,
                color: t.color,
                isVisible: t.league === _this.lineChartCurrentLeague
            }); });
        },
        lineChartXAxisLabelList: function () {
            return this.numberOfVisitorsHistory
                .map(function (s) { return s.season; })
                .reverse();
        },
        seasonOptionList: function () {
            return this.numberOfVisitorsHistory.map(function (h) { return h.season; });
        },
        barChartCurrentSeasonList: function () {
            var _this = this;
            var currentSeason = this.numberOfVisitorsHistory.find(function (h) { return h.season === _this.barChartCurrentSeason; });
            if (!currentSeason) {
                return [];
            }
            return currentSeason
                .data
                .map(function (d) { return d.value / 1000; });
        },
        barChartPropsList: function () {
            var _this = this;
            return this.teams
                .map(function (t) { return ({
                id: t.id,
                name: t.name,
                color: t.color,
                isVisible: t.league === _this.barChartCurrentLeague
            }); });
        },
        pieChartCurrentSeasonList: function () {
            var _this = this;
            var currentSeason = this.numberOfVisitorsHistory.find(function (h) { return h.season === _this.pieChartCurrentSeason; });
            if (!currentSeason) {
                return [];
            }
            return currentSeason
                .data
                .map(function (d) { return d.value / 1000; });
        },
        pipeChartPropsList: function () {
            var _this = this;
            return this.teams
                .map(function (t) { return ({
                id: t.id,
                name: t.name,
                color: t.color,
                isVisible: t.league === _this.pieChartCurrentLeague
            }); });
        }
    },
    methods: {
        fetchAll: function () {
            return Promise.all([
                fetchNpbLeagues(),
                fetchNpbTeams(),
                fetchNpbNumberOfVisitorsHistory(),
                fetchNpbPennantRaceHistory()
            ]);
        },
        handleClickLineChartTabItem: function (index) {
            this.lineChartCurrentLeague = index;
        },
        handleClickBarChartTabItem: function (index) {
            this.barChartCurrentLeague = index;
        },
        handleClickPieChartTabItem: function (index) {
            this.pieChartCurrentLeague = index;
        }
    },
    created: function () {
        var _this = this;
        this.fetchAll()
            .then(function (resps) {
            var leagues = resps[0], teams = resps[1], numberOfVisitorsHistory = resps[2], pennantRaceHistory = resps[3];
            var lastSeason = Math.max.apply(Math, numberOfVisitorsHistory.map(function (h) { return h.season; }));
            Object.assign(_this, {
                leagues: leagues,
                teams: teams,
                numberOfVisitorsHistory: numberOfVisitorsHistory,
                pennantRaceHistory: pennantRaceHistory,
                barChartCurrentSeason: lastSeason,
                pieChartCurrentSeason: lastSeason
            });
        })
            .catch(function (err) { return console.error(err.message); });
    }
}));

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec1a0840","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App/app.vue
var app_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Line chart")]),_vm._v(" "),_c('p',[_vm._v("History of NPB's annual visitors.")]),_vm._v(" "),_c('TabList',{attrs:{"labels":_vm.tabLabels},on:{"click-item":_vm.handleClickLineChartTabItem}}),_vm._v(" "),_c('ChartLine',{attrs:{"series":_vm.lineChartHistoryList,"lines":_vm.lineChartPropsList,"xAxisLabels":_vm.lineChartXAxisLabelList,"yAxisUnit":"x 1000"}})],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Bar chart")]),_vm._v(" "),_c('p',[_vm._v("Annual visitors per team")]),_vm._v(" "),_c('div',{staticClass:"comb-tab-select"},[_c('TabList',{attrs:{"labels":_vm.tabLabels},on:{"click-item":_vm.handleClickBarChartTabItem}}),_vm._v(" "),_c('p',{staticClass:"comb-tab-select__select"},[_c('span',[_vm._v("Season: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.barChartCurrentSeason),expression:"barChartCurrentSeason"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.barChartCurrentSeason=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.seasonOptionList),function(season){return _c('option',{key:season,domProps:{"value":season}},[_vm._v(_vm._s(season))])}))])],1),_vm._v(" "),_c('ChartBar',{attrs:{"series":_vm.barChartCurrentSeasonList,"forcedMinValue":0,"lines":_vm.barChartPropsList,"yAxisUnit":"x 1000"}})],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('h2',[_vm._v("Pie chart")]),_vm._v(" "),_c('p',[_vm._v("Annual visitors per team")]),_vm._v(" "),_c('div',{staticClass:"comb-tab-select"},[_c('TabList',{attrs:{"labels":_vm.tabLabels},on:{"click-item":_vm.handleClickPieChartTabItem}}),_vm._v(" "),_c('p',{staticClass:"comb-tab-select__select"},[_c('span',[_vm._v("Season: ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.pieChartCurrentSeason),expression:"pieChartCurrentSeason"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.pieChartCurrentSeason=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.seasonOptionList),function(season){return _c('option',{key:season,domProps:{"value":season}},[_vm._v(_vm._s(season))])}))])],1),_vm._v(" "),_c('ChartPie',{attrs:{"series":_vm.pieChartCurrentSeasonList,"pies":_vm.pipeChartPropsList}})],1),_vm._v(" "),_vm._m(1,false,false)])}
var app_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"container"},[_c('h1',[_vm._v("Vue Graph Demo")]),_vm._v(" "),_c('p',[_vm._v("Demos of graph that render by Vue.js without D3.js.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"container"},[_c('p',[_c('a',{attrs:{"href":"https://github.com/haribote/vue-graph-demo","target":"_blank"}},[_vm._v("Fork on GitHub")])])])}]
var app_esExports = { render: app_render, staticRenderFns: app_staticRenderFns }
/* harmony default export */ var App_app = (app_esExports);
// CONCATENATED MODULE: ./src/components/App/app.vue
function app_injectStyle (ssrContext) {
  __webpack_require__("na0M")
}
var app_normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* template functional */
var app___vue_template_functional__ = false
/* styles */
var app___vue_styles__ = app_injectStyle
/* scopeId */
var app___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var app___vue_module_identifier__ = null
var app_Component = app_normalizeComponent(
  app,
  App_app,
  app___vue_template_functional__,
  app___vue_styles__,
  app___vue_scopeId__,
  app___vue_module_identifier__
)

/* harmony default export */ var components_App_app = (app_Component.exports);

// CONCATENATED MODULE: ./src/main.ts


vue_runtime_esm["a" /* default */].config.productionTip = false;
/* tslint:disable-next-line:no-unused-expression */
new vue_runtime_esm["a" /* default */]({
    el: '#app',
    render: function (h) { return h(components_App_app); }
});


/***/ }),

/***/ "yArI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["x35b"]);


// WEBPACK FOOTER //
// static/js/app.2c762ebd280433240438.js